import { styled, ThemeOptions } from "@mui/material/styles";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

interface StyledTableContainerProps {
  hasData: boolean;
}
export const StyledTableContainer = styled(TableContainer, {
  shouldForwardProp: (prop) => prop !== 'hasData'
})<StyledTableContainerProps>(({ theme, hasData }) => ({
  maxHeight: hasData ? 440 : "auto",
  height: hasData ? "440px" : "auto",
  overflow: hasData ? "auto" : "visible",
  "& .MuiTable-root": {
    borderCollapse: "separate",
    borderSpacing: 0,
    boxShadow: "none",
    borderBottom: "none",
  },
  scrollbarColor: "rgba(43, 54, 116, 0.3) rgba(255, 255, 255, 0.5)",
}));

export const StyledTotalRow = styled(TableRow)(({ theme }) => ({
  fontWeight: 500,
  backgroundColor: "rgba(255, 255, 255, 1)",
  "& .MuiTableCell-root": {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "16px",
    borderBottom: "none",
  },
  position: "sticky",
  bottom: 0,
  zIndex: 2,
}));

export const createTableTheme = (
  langTheme: any,
  isRTL: boolean
): ThemeOptions => ({
  typography: {
    fontFamily: langTheme.mainFont(),
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid rgba(224, 229, 242, 1)",
          fontFamily: langTheme.mainFont(),
          color: "rgba(43, 54, 116, 1)",
          fontWeight: 500,
          fontSize: "16px",
          lineHeight: "16px",
          textAlign: isRTL ? "right" : "left",
        },
        head: {
          position: "sticky",
          top: 0,
          color: "rgba(43, 54, 116, 0.74)",
          fontWeight: 500,
          fontSize: "16px",
          lineHeight: "16px",
          textAlign: isRTL ? "right" : "left",
          "&::after": {
            content: '""',
            position: "absolute",
            [isRTL ? "right" : "left"]: 2,
            top: "50%",
            transform: "translateY(-50%)",
            height: "40%",
            width: "1px",
            backgroundColor: "rgba(224, 229, 242, 1)",
          },
          "&::before": {
            content: '""',
            position: "absolute",
            [isRTL ? "right" : "left"]: 6,
            top: "50%",
            transform: "translateY(-50%)",
            height: "40%",
            width: "1px",
            backgroundColor: "rgba(224, 229, 242, 1)",
          },
          "&:first-of-type::after, &:first-of-type::before": {
            display: "none",
          },
        },
      },
    },
  },
});
